var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTest({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3504_8408)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0625 0C9.30386 6.24291e-06 9.54096 0.064698 9.74998 0.187573C9.959 0.310449 10.1326 0.487178 10.2533 0.7H11.125C11.4897 0.7 11.8394 0.847499 12.0973 1.11005C12.3551 1.3726 12.5 1.7287 12.5 2.1V10.5C12.5 11.4283 12.1378 12.3185 11.4932 12.9749C10.8485 13.6313 9.97418 14 9.0625 14H2.875C2.51033 14 2.16059 13.8525 1.90273 13.5899C1.64487 13.3274 1.5 12.9713 1.5 12.6V2.1C1.5 1.7287 1.64487 1.3726 1.90273 1.11005C2.16059 0.847499 2.51033 0.7 2.875 0.7H3.74675C3.86743 0.487178 4.041 0.310449 4.25002 0.187573C4.45904 0.064698 4.69614 6.24291e-06 4.9375 0H9.0625ZM3.5625 2.1H2.875V12.6H9.0625C9.60951 12.6 10.1341 12.3788 10.5209 11.9849C10.9077 11.5911 11.125 11.057 11.125 10.5V2.1H10.4375C10.4375 2.4713 10.2926 2.8274 10.0348 3.08995C9.77691 3.3525 9.42717 3.5 9.0625 3.5H4.9375C4.57283 3.5 4.22309 3.3525 3.96523 3.08995C3.70737 2.8274 3.5625 2.4713 3.5625 2.1ZM9.91363 5.1653C10.0425 5.29657 10.1149 5.47459 10.1149 5.6602C10.1149 5.84582 10.0425 6.02383 9.91363 6.1551L6.5105 9.6201C6.38157 9.75133 6.20674 9.82505 6.02444 9.82505C5.84214 9.82505 5.6673 9.75133 5.53837 9.6201L4.08088 8.1347C3.95865 8.00217 3.89185 7.82642 3.89462 7.64464C3.89739 7.46286 3.96952 7.28931 4.09573 7.16072C4.22194 7.03212 4.39234 6.95856 4.57088 6.95561C4.74941 6.95266 4.92207 7.02054 5.05231 7.1449L6.02513 8.1347L8.9415 5.1653C9.07043 5.03407 9.24526 4.96035 9.42756 4.96035C9.60986 4.96035 9.7847 5.03407 9.91363 5.1653ZM9.0625 1.4H4.9375V2.1H9.0625V1.4Z",
    fill: "#7E8CA8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3504_8408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest);
export default __webpack_public_path__ + "static/media/test.436eee361b3200ad7c463308b20f6905.svg";
export { ForwardRef as ReactComponent };